import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ReciboMultiploService } from './../../../services/recibo-multiplo.service';
import { Baixa } from '@app/models/baixa.model';
import { Recibo } from '@app/models/recibo.model';

@Component({
  selector: 'app-recibo-multiplo',
  templateUrl: './recibo-multiplo.component.html',
  styleUrls: ['./recibo-multiplo.component.scss'],
})
export class ReciboMultiploComponent implements OnInit {
  listaRecibosBaixa: Baixa[] = [];
  recibos: Recibo[] = [];
  tipo = '';

  constructor(
    private route: ActivatedRoute,
    private reciboMultiploService: ReciboMultiploService
  ) { }

  ngOnInit() {
    this.listaRecibosBaixa = JSON.parse(window.localStorage.getItem('recibos'));

    this.tipo = this.listaRecibosBaixa[0].Tipo === 'P' ? 'P' : 'R';

    this.reciboMultiploService
      .obterRecibos(this.listaRecibosBaixa)
      .toPromise()
      .then((data) => {
        this.recibos = data;
        setTimeout(() => {
          if (data !== null || data !== undefined) {
            window.print();
          }
          // Aqui a linha que chama a impressão do recibo
        }, 500);
      });
  }
}
